import React, { useState, useEffect } from 'react';
import { 
  Paper, Typography, Box, Skeleton, useTheme, 
} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { DateTime } from 'luxon';
import { useHistory } from 'react-router-dom';

const NextEventsWidget = ({ t , events, loading}) => {
  const theme = useTheme();
  const history = useHistory();

  return (
    <Paper
        id="next-shifts" 
        elevation={0} 
        sx={{ 
          mb: 1, mx: 0, width: '100%',
          overflow: 'hidden', 
          borderRadius: '16px', 
          border: '1px solid #e2e8f0', 
          bgcolor: '#f8fafc' 
        }}
    >
      {/* HEADER: Clonazione esatta del Segnala Presenza */}
      <Box sx={{ 
               p: 2, 
               bgcolor: '#fff', 
               borderBottom: '1px solid #e2e8f0',
               display: 'flex',
               justifyContent: 'space-between',
               alignItems: 'center'
             }}>
        <Typography 
            variant="subtitle1" 
            sx={{ 
              color: '#1a365d', 
              fontWeight: 800, 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1.5,
              textTransform: 'uppercase',
              letterSpacing: 1
            }}
          >
            <CalendarMonthIcon />
             {t("I Miei Prossimi Turni")}
          </Typography>


      </Box>

      {/* BODY: I singoli eventi */}
      {loading ? (
        // SKELETON: Ora è sincronizzato con il caricamento della Home
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Skeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: '12px' }} />
          <Skeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: '12px' }} />
        </Box>
      ) : (
      <Box sx={{ display: 'flex', flexDirection: 'column', my:1 }}>
        {events.length > 0 ? (
          events.map((event, index) => {
            const isSport = event.tipoTurno === 'SPORTIVI';
            const is112 = event.tipoTurno === 'SHIFT';
            const isTemplate = event.tipoTurno === 'TEMPLATE';
            const dt = DateTime.fromISO(event.dataInizio).setLocale('it');
            const dtEnd = DateTime.fromISO(event.dataFine).setLocale('it');
            return (
              <Box 
                key={index}
                onClick={() => {
                if (isSport) {
                  const date = new Date(event.dataInizio);
                  history.push({
                    pathname: '/app/sportivi',
                    state: { 
                      targetYear: date.getFullYear(), targetMonth: date.getMonth(),
                      targetEventId: event.id 
                    }
                  });
                }
                if (is112) {
                  const date = new Date(event.dataInizio);
                  history.push({
                    pathname: `/app/calendarxls/${event.anaCalendarId}`,
                    state: { 
                      targetYear: date.getFullYear(), targetMonth: date.getMonth(),
                      targetEventId: event.id 
                    }
                  });
                }
                if (isTemplate) {
                  const date = new Date(event.dataInizio);
                  history.push({
                    pathname: `/app/calendartemplate/${event.anaCalendarId}`,
                    state: { 
                      targetYear: date.getFullYear(), targetMonth: date.getMonth(),
                      targetEventId: event.id 
                    }
                  });
                }
              }}
                sx={{ 
                  p: 2, 
                  mx: 1.5, my:1,
                  borderRadius: 3, 
                  bgcolor: '#fff', 
                  border: '1px solid rgba(0,0,0,0.04)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  transition: 'transform 0.2s',
                  '&:hover': { transform: 'scale(1.01)' }
                }}
              >
                {/* Icona Tipo Evento */}
                <Box sx={{ 
                  p: 1, 
                  borderRadius: 2, 
                  bgcolor: isSport ? 'warning.light' : 'primary.light',
                  color: isSport ? 'warning.main' : 'primary.main',
                  display: 'flex',
                  opacity: 0.8
                  }}
                  
                >
                  {isSport ? <EmojiEventsIcon fontSize="small" /> : <AccessTimeIcon fontSize="small" />}
                </Box>

                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, color: '#2d3748', lineHeight: 1.2 }}>
                    {event.dettagliTurno}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                    {dt.toFormat('ccc dd LLL').toUpperCase()} • {dt.toFormat('HH:mm')} - {dtEnd.toFormat('HH:mm')}
                  </Typography>
                </Box>

                <Box sx={{ textAlign: 'right' }}>
                  <Typography sx={{ 
                    fontWeight: 900, 
                    color: isSport ? '#ed8936' : '#3182ce',
                    fontSize: '0.7rem',
                    textTransform: 'uppercase'
                  }}>
                    {dt.hasSame(DateTime.now(), 'day') ? t('Oggi') : dt.toFormat('dd/MM')}
                  </Typography>
                </Box>
              </Box>
            );
          })
        ) : (
          <Box sx={{ py: 2, textAlign: 'center' }}>
             <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
              {t("Nessun impegno in programma")}
            </Typography>
          </Box>
        )}
      </Box>)}
    </Paper>
  );
};

export default NextEventsWidget;